export default __webpack_public_path__ + "static/media/Glacial_Lakes.c32ada40.webp";